import createIsValid from './isValid';
export default function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = createIsValid(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/isInvalid.js
// module id = 2147
// module chunks = 1